import parseIntId from "./parseIntId";

export function entityLookup(entities, id) {
  const idInt = parseIntId(id);
  if (idInt === 0) return null;

  return entities[idInt.toString()];
}
